import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('../views/Partners.vue')
    },
    {
      path: '/integrations',
      name: 'integrations',
      component: () => import('../views/Integrations.vue')
    },
    {
      path: '/docs',
      name: 'docs',
      component: () => import('../views/Docs.vue')
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('../views/blog/Blog.vue')
    },
    {
      path: '/blog/:slug',
      name: 'blog-post',
      component: () => import('../views/blog/BlogPost.vue')
    },
    {
      path: '/status',
      name: 'status',
      component: () => import('../views/Status.vue')
    },
    {
      path: '/investors',
      name: 'investors',
      component: () => import('../views/Investors.vue')
    },
    {
      path: '/data-centers',
      name: 'data-centers',
      component: () => import('../views/DataCenters.vue')
    },
    {
      path: '/about/story',
      name: 'story',
      component: () => import('../views/about/Story.vue')
    },
    {
      path: '/about/mission',
      name: 'mission',
      component: () => import('../views/about/Mission.vue')
    },
    {
      path: '/careers',
      name: 'careers',
      component: () => import('../views/about/Careers.vue')
    },
    {
      path: '/careers/apply',
      name: 'apply',
      component: () => import('../views/about/Apply.vue')
    },
    {
      path: '/media/press',
      name: 'press',
      component: () => import('../views/media/Press.vue')
    },
    {
      path: '/media/media-kit',
      name: 'media-kit',
      component: () => import('../views/media/MediaKit.vue')
    },
    {
      path: '/media/awards',
      name: 'awards',
      component: () => import('../views/media/Awards.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/Contact.vue')
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('../views/Services.vue')
    },
    {
      path: '/security',
      name: 'security',
      component: () => import('../views/Security.vue')
    },
    {
      path: '/api-docs',
      name: 'api-docs',
      component: () => import('../views/ApiDocs.vue')
    },
    {
      path: '/legal/terms',
      name: 'terms',
      component: () => import('../views/legal/Terms.vue')
    },
    {
      path: '/legal/privacy',
      name: 'privacy',
      component: () => import('../views/legal/Privacy.vue')
    },
    {
      path: '/legal/acceptable-use',
      name: 'acceptable-use',
      component: () => import('../views/legal/AcceptableUse.vue')
    },
    {
      path: '/compute/dedicated-cpu',
      name: 'dedicated-cpu',
      component: () => import('../views/compute/DedicatedCPU.vue')
    },
    {
      path: '/compute/shared-cpu',
      name: 'shared-cpu',
      component: () => import('../views/compute/SharedCPU.vue')
    },
    {
      path: '/compute/dedicated-gpu',
      name: 'dedicated-gpu',
      component: () => import('../views/compute/DedicatedGPU.vue')
    },
    {
      path: '/compute/bare-metal',
      name: 'bare-metal',
      component: () => import('../views/compute/BareMetal.vue')
    },
    {
      path: '/compute/colocation',
      name: 'colocation',
      component: () => import('../views/compute/Colocation.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFound.vue')
    }
  ]
})

export default router
